import { jsx as _jsx } from "react/jsx-runtime";
import OptionList from './OptionList';
import { getTranslation } from '../translations';
const PosUnitSelector = ({ posUnits, environment, company, loading, error, onSelect, }) => {
    const labels = getTranslation();
    return (_jsx(OptionList, { title: labels.selectPosUnit, context: `${labels.environment} ${environment} · ${labels.company} ${company}`, loading: loading, error: error, options: posUnits.map((posUnit) => ({
            id: posUnit.id,
            label: posUnit.code,
            detail: posUnit.name,
            value: posUnit.code,
        })), onSelect: onSelect }));
};
export default PosUnitSelector;
